export default class NotifyValidationError extends Error {
    guids: Array<string>

    constructor(message: string, guids: Array<string>) {
        super(message);

        this.guids = guids
    }
}